import { BroadcastChannel } from "broadcast-channel";
import { LocalStorage } from "../../util/Utils";

const logoutChannel = new BroadcastChannel("logout");

export const logout = () => {
  logoutChannel.postMessage("Logout");
  LocalStorage.remove(undefined, true);
  window.location.href = window.location.origin + window.location.pathname;
};

export const logoutAllTabs = () => {
  logoutChannel.onmessage = () => {
    logout();
    logoutChannel.close();
  };
};
